import axios from 'axios';
import { IBaseProjectResumeConfig } from '../models/projectResumeConfigModel';

const loadAbort = () => {
  return new AbortController();
};

export const getResumeProjectInitialConfigEndpoint = (
  projectId: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/initial-project-resume`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getResumeProjectConfigEndpoint = (
  projectId: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/project-resume-config`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createResumeProjectConfigEndpoint = (
  projectId: string,
  payload: IBaseProjectResumeConfig,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'POST',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/project-resume-config`,
        data: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const updateResumeProjectConfigEndpoint = (
  id: string,
  payload: IBaseProjectResumeConfig,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'PUT',
        url: `${urlService}/pre-sales/v1/admin/projects/${id}/project-resume-config/${id}`,
        data: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
